import { I18n } from "../services/I18n";
import "./generated/site-translations-es";
import common_es from "../../../../../libs/ps/restaumatic-common/locales/es.json";
import core_types_sites_es from "../../../../../libs/ps/restaumatic-core-types-sites/locales/es.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  es: { _core_types_sites: core_types_sites_es },
});
I18n.translations = I18n.extend(I18n.translations, {
  es: { _common: common_es },
});
